export default __webpack_public_path__ + "static/media/matkaBg.08b8abf1.jpg";